<template>
  <svg
    :width="width ? width : height ? height * (11 / 18) : 11"
    :height="height ? height : width ? width * (18 / 11) : 18"
    viewBox="0 0 11 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Desktop-2b---A-til-B"
        transform="translate(-239.000000, -321.000000)"
        :fill="iconColor"
        fill-rule="nonzero"
      >
        <g id="Group-18" transform="translate(80.137208, 301.767002)">
          <path
            d="M165.954394,22.8551492 C166.810589,22.8551492 167.505237,22.1605009 167.505237,21.3043064 C167.505237,20.4481119 166.810589,19.7534636 165.954394,19.7534636 C165.0982,19.7534636 164.403551,20.4481119 164.403551,21.3043064 C164.403551,22.1605009 165.0982,22.8551492 165.954394,22.8551492 Z M169.007616,27.6724548 L168.254811,27.2912059 L167.941412,26.3413147 C167.466466,24.9003232 166.141788,23.8922754 164.639409,23.8890444 C163.476277,23.8858135 162.833323,24.2153676 161.624958,24.7032369 C160.927079,24.9843272 160.355205,25.5174294 160.019189,26.1959232 L159.802718,26.6353286 C159.550706,27.1458144 159.754254,27.7661515 160.261509,28.0213944 C160.765532,28.2766373 161.379408,28.0698583 161.634651,27.5593725 L161.851122,27.119967 C161.964205,26.8938024 162.151598,26.7161017 162.384225,26.6224049 L163.250112,26.2734653 L162.759012,28.2346353 C162.591004,28.9066672 162.771935,29.6207011 163.240419,30.1344178 L165.175742,32.2474411 C165.408368,32.502684 165.573145,32.8096217 165.657149,33.1424067 L166.248408,35.5106729 C166.387338,36.0631607 166.949518,36.4024076 167.502006,36.2634779 C168.054494,36.1245482 168.393741,35.5623677 168.254811,35.0098799 L167.537546,32.1343588 C167.453542,31.8015738 167.288765,31.4914053 167.056139,31.2393933 L165.586069,29.6336248 L166.141788,27.413981 L166.319488,27.9470832 C166.490727,28.4672617 166.859052,28.8969744 167.343691,29.1425245 L168.096496,29.5237734 C168.60052,29.7790163 169.214395,29.5722372 169.469638,29.0617515 C169.718419,28.5544966 169.514871,27.9276977 169.007616,27.6724548 Z M161.612034,32.2183628 C161.508645,32.4800676 161.35356,32.7159249 161.153243,32.9130112 L159.537782,34.5317034 C159.133917,34.9355687 159.133917,35.591446 159.537782,35.9953113 C159.941647,36.3991766 160.594294,36.3991766 160.998159,35.9953113 L162.917327,34.0761433 C163.114413,33.879057 163.269497,33.6431997 163.376118,33.381495 L163.812292,32.2894431 C162.025592,30.3411968 162.561925,30.9389175 162.280835,30.5544377 L161.612034,32.2183628 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'walk',
  props: {
    iconColor: {
      type: String,
      default: '#0F1C70',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
